import React from 'react';
import Header from '../components/header';
import BreadCrumbsBar from '../components/breadCrumbsBar';
import Footer from '../components/footer';
import Cloud from '../components/cloud';
function BusinessCloudPBXPage() {
    return (
      <div>
        <Header />
        <BreadCrumbsBar />
        <Cloud />
        <Footer />
      </div>
    );
  }

 export default BusinessCloudPBXPage; 
  
  